import React, { useState , useEffect } from "react";
import BannerWrapper from "../../component/Banner_Wrapper";
import BYP_Transiton_Card from "../../component/BYP_Transition_Card";
import { useIsMobile } from "../../Hooks/useIsMobile";
import {useSelector}  from "react-redux"
import {
  PrimeSenior,
  SuperTopup,
  ProHealth,
  Lifetime,
  PrimeProhealth,
  CI,
  PA,
  Ring,
} from "../../assets/index";
import { typeOfCal } from "../../Constant";
import axios from "axios";
import { intersubcatSelected } from "../../Redux/IntermediaryReducer";
import SimpleBannerWrapper from "../../component/Banner_Wrapper/SimpleBanner";
import { Image } from "antd";

const Home = () => {
  const [paramsData, setParamsData] = useState();
  const [showLoader, setShowLoader] = useState(false);
  const [parentagencyid, setParentAgencyId] = useState("");
  const isMobile = useIsMobile();
  const typeOfCalculator = useSelector((s) => s.common.type);
  const agentDataSelected = useSelector((state) => state.agData.agentData);
  const [data, setData] = useState([
    {
      type: typeOfCal.mchiSarvah,
      label: "Sarvah",
      image: Ring,
      id: 8,
      subMenuClicked: false,
    },
    {
      type: typeOfCal.lifetime,
      label: "Lifetime Health",
      image: Lifetime,
      id: 0,
      subMenuClicked: false,
    },
    {
      type: typeOfCal.prohealthPrime,
      label: "ProHealth Prime",
      image: PrimeProhealth,
      id: 1,
      subMenuClicked: false,
    },
    {
      type: typeOfCal.primeSenior,
      label: "Prime Senior",
      image: PrimeSenior,
      id: 2,
      subMenuClicked: false,
    },
    // {
    //   type: typeOfCal.prohealth,
    //   label: "ProHealth",
    //   image: ProHealth,
    //   id: 3,
    //   subMenuClicked: false,
    // },
    {
      type: typeOfCal.superTopUp,
      label: "Super Top Up",
      image: SuperTopup,
      id: 4,
      subMenuClicked: false,
    },
    {
      type: typeOfCal.ci,
      label: "Critical Illness",
      image: CI,
      id: 5,
      subMenuClicked: false,
    },
    {
      type: typeOfCal.pa,
      label: "Personal Accident",
      image: PA,
      id: 6,
      subMenuClicked: false,
    },
    {
      type: typeOfCal.accident_Shield,
      label: "Accident Shield",
      image: PA,
      id: 7,
      subMenuClicked: false,
    },
  ]);
  useEffect(() => {
    getQuery();
  }, []);
  const getQuery = () => {
    let search = window.location.search;
    let params = new URLSearchParams(search);
    //env key
    var key = "lv39eptlvuhaqqer";
  if(params){
    var parentagencyid = params.get("parentagencyid");
    if (parentagencyid !== null) {
        getPortalDetails(parentagencyid);
    }
  }
  };

  const getPortalDetails = (parentagencyid) => {
    setShowLoader(true);
    var config = {
      method: "post",
      url: process.env.REACT_APP_Sell_Url  + "getDistributionPortalDetails?parentAgencyId=" + parentagencyid,
      headers: {
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function (response) {
        let arr=[];
        if(response.data.response){
          response.data.response.forEach(element => {
            let obj = {
              type: typeOfCal + "." + element.productName,
              label: element.productName,
              image: element.productName,
              id: 2,
              subMenuClicked: false,
            }
            arr.push(obj);
          });
       setData(arr);
        }
        setShowLoader(false);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  return (
    <div>
      <SimpleBannerWrapper>
        <div
          className="row align-items-start container gy-3"
          style={{ marginTop: `${isMobile ? "-60px" : "-70px"}` }}
        >
          {data.map((ei, i) => (
            <>
              <div className="col-md-3">
                <BYP_Transiton_Card
                  key={`card-${ei.id}`}
                  data={ei}
                  onSubmenuChange={() => {
                    const newArr = [...data];
                    newArr[i].subMenuClicked = !data[i].subMenuClicked;
                    setData(newArr);
                  }}
                />
              </div>
            </>
          ))}
        </div>
      </SimpleBannerWrapper>
    </div>
  );
};

export default Home;
